import {
  GET_SETTING_COIN,
  GET_SETTING_COIN_SUCCESS,
  GET_SETTING_COIN_FAILED,
  UPDATE_SETTING_COIN,
  UPDATE_SETTING_COIN_SUCCESS,
  UPDATE_SETTING_COIN_FAILED,
  GET_HISTORY_COIN,
  GET_HISTORY_COIN_SUCCESS,
  GET_HISTORY_COIN_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetSettingCoin: false,
  isLoadingUpdateSettingCoin: false,
  settingCoin: {},

  isLoadingGetHistoryCoin: false,
  historyCoinList: [],
  historyCoinTotal: 0,
};

export default function manageCoin(state = initialState, action) {
  switch (action.type) {
    case GET_SETTING_COIN:
      return {
        ...state,
        isLoadingGetSettingCoin: true,
      };

    case GET_SETTING_COIN_SUCCESS:
      return {
        ...state,
        isLoadingGetSettingCoin: false,
        settingCoin: action.payload,
      };

    case GET_SETTING_COIN_FAILED:
      return {
        ...state,
        isLoadingGetSettingCoin: false,
      };

    case UPDATE_SETTING_COIN:
      return {
        ...state,
        isLoadingUpdateSettingCoin: true,
      };

    case UPDATE_SETTING_COIN_SUCCESS:
      return {
        ...state,
        isLoadingUpdateSettingCoin: false,
        settingCoin: action.payload,
      };

    case UPDATE_SETTING_COIN_FAILED:
      return {
        ...state,
        isLoadingUpdateSettingCoin: false,
      };

    case GET_HISTORY_COIN:
      return {
        ...state,
        isLoadingGetHistoryCoin: true,
      };

    case GET_HISTORY_COIN_SUCCESS:
      return {
        ...state,
        isLoadingGetHistoryCoin: false,
        historyCoinList: action.payload.data || [],
        historyCoinTotal: action.payload.total || 0,
      };

    case GET_HISTORY_COIN_FAILED:
      return {
        ...state,
        isLoadingGetHistoryCoin: false,
      };

    default:
      return state;
  }
}
